<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm12 md12>
        <v-toolbar class="primary white--text">
          <v-toolbar-title class="headline text-xs-center">
            Shop Settings
          </v-toolbar-title>
          <v-spacer />
        </v-toolbar>
        <v-card>
          <v-card-text>
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex xs12 sm6 md6>
                  <v-switch
                    v-model="currentSettings.active"
                    :label="`${
                      'Shop Active: ' + (currentSettings.active ? 'YES' : 'NO')
                    }`"
                  ></v-switch>
                </v-flex>
                <v-flex xs12 sm6 md6>
                  <v-select
                    dense
                    :items="firmsByBrand"
                    label="Select Firm"
                    item-text="text"
                    item-value="value"
                    v-model="currentSettings.firm"
                  ></v-select>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <span>
                    <label for="filesLogo" class="title mat-raised-button">
                      <span style="font-weight: bold; color: #2727b0">{{
                        currentSettings.logo
                          ? "Change Logo Image"
                          : "Upload Logo Image"
                      }}</span>
                    </label>
                    <input
                      id="filesLogo"
                      @change="uploadChangeLogo($event)"
                      accept=".png,.jpg"
                      style="visibility: hidden"
                      type="file"
                    />
                  </span>
                  <span v-if="brandLogo">{{ brandLogo.name }}</span>
                  <span v-if="uploadValue != 0">{{ uploadValue }}%</span>
                </v-flex>
                <v-flex xs12 sm12 md12 v-if="currentSettings.logo">
                  <img
                    :src="currentSettings.logo"
                    height="250px"
                    width="250px"
                    style="object-fit: cover"
                  />
                </v-flex>
                <v-flex xs-12 v-if="currentSettings.firm">
                  <v-btn
                    color="blue darken-1"
                    @click="addAllProds()"
                    flat
                    >RESET Product List</v-btn
                  >
                </v-flex>
                <v-flex xs12 v-if="currentSettings.firm">
                    <template v-for="(item, index) in currentSettings.items">
                  <v-layout wrap :key="index + item.productId + 'name'">
                      <v-flex
                        
                        xs2
                        sm2
                        md2
                        v-if="item.orignal"
                      >
                         <v-text-field
                          :disabled="true"
                          label="Product Name"
                          :value="getProd(item.productId).name"
                        ></v-text-field>
                      </v-flex>
                         <v-flex
            
                        xs2
                        sm2
                        md2
                        v-else
                      >
                        <v-select
                          dense
                          item-text="name"
                          :item-value="'name'"
                          :items="productsByFirm"
                          label="Product Name"
                          v-model="item.productName"
                          @change="restructureProductList(index)"
                        ></v-select>
                      </v-flex>
                      <v-flex xs2 sm2 md2  v-if="item.orignal">
                        <v-text-field
                          :disabled="true"
                          label="Unit"
                          :value="getProd(item.productId).unit"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs2 sm2 md2 v-else>
                        <v-select
                          v-if="item.productName"
                          dense
                          item-text="text"
                          item-value="value"
                          :items="units"
                          label="Select unit"
                          :disabled="item.orignal"
                          v-model="item.unit"
                        ></v-select>
                      </v-flex>
                      <v-flex
                        xs2
                        sm2
                        md2
                        v-if="item.orignal"
                      >
                        <v-text-field
                          :disabled="true"
                          label="Rate (MRP)"
                          :value="getProd(item.productId).MRPRate"
                        >
                        </v-text-field>
                      </v-flex>
                       <v-flex
                        xs2
                        sm2
                        md2
                        v-else
                      >
                        <v-text-field
                          v-if="item.productName"
                          type="number"
                          v-model.number="item.MRPRate"
                          label="Rate (MRP)"
                          :disabled="item.orignal"
                        >
                        </v-text-field>
                      </v-flex>
                       <v-flex
                        xs2
                        sm2
                        md2
                        v-if="item.orignal"
                      >
                        <v-text-field
                           :disabled="true"
                          label="Rate After Discount"
                          :value="getProd(item.productId).sellingPrice"
                        >
                        </v-text-field>
                      </v-flex>
                        <v-flex
                        xs2
                        sm2
                        md2
                        v-else
                      >
                        <v-text-field
                          v-if="item.productName"
                          type="number"
                          v-model.number="item.rate"
                          :disabled="item.orignal"
                          label="Rate After Discount"
                        >
                        </v-text-field>
                      </v-flex>
                       <v-flex
                        xs2
                        sm2
                        md2
                      >
                          <a
                            v-if="item.image.documentName"
                            @click="downloadURI(item.image.filePath, item.image.documentName)"
                            >{{ item.image.documentName }}</a
                          >

                          <label
                            :for="'prod-image' + index"
                            class="title mat-raised-button"
                          >
                            <v-icon
                              large
                              color="primary"
                              v-if="item.image.filePath"
                            >
                              mode
                            </v-icon>
                            <v-icon
                              large
                              color="primary"
                              v-else
                            >
                              file_upload
                            </v-icon>
                          </label>
                          <input
                            :id="'prod-image' + index"
                            @change="uploadChangeProduct($event, item.image, index)"
                            style="visibility: hidden;width: 5px;"
                            type="file"
                          />
                      </v-flex>
                      <v-flex
                        xs2
                        sm2
                        md2
                      >
                        <v-btn
                          icon
                          color="primary"
                          v-if="
                            index == currentSettings.items.length - 1 &&
                            (item.productName || item.productId)
                          "
                          @click="addProd()"
                        >
                          <v-icon>add_circle</v-icon>
                        </v-btn>
                        <v-btn
                          icon
                          color="primary"
                          @click="removeProd(index)"
                          v-else-if="item.productName || item.productId"
                        >
                          <v-icon>cancel</v-icon>
                        </v-btn>
                      </v-flex>
                  </v-layout>
                   </template>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              @click="uploadAndSave"
              flat
              v-if="!currentSettings['.key']"
              >Save</v-btn
            >
            <v-btn
              color="blue darken-1"
              @click="uploadAndSave"
              flat
              v-if="!!currentSettings['.key']"
              >Update</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
      <v-snackbar
      v-model="snackbar"
      :timeout="3000"
    >
    Shop Settings updated!
    </v-snackbar>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import firebase from "firebase";
let logoPath = "shop-images/";
let productsImagesPath = "shop-images/products/";
export default {
  data() {
    return {
      brandLogo: null,
      uploadValue: 0,
      snackbar : false,
      productImages : {},
      currentSettings: {
        firm: null,
        logo: null,
        logoFileName: null,
        active: false,
        name: null,
        items: [
          {
            productName: null,
            productId: null,
            unit: null,
            rate: 0,
            MRPRate : 0,
            image : {
              fileName: null,
              filePath: null,
              uploadDate: null,
              documentName: null,
            }
          },
        ],
      },
    };
  },
  created() {
    this.$bindAsArray(
      "firms",
      this.$root.$firebaseRefs.firm
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "shopSettings",
      this.$root.$firebaseRefs.shopSettings
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    );
    this.$bindAsArray(
      "products",
      this.$root.$firebaseRefs.products
        .orderByChild("brand")
        .equalTo(this.selectedBrand)
    ),
      this.getCurrentSettings();
  },
  watch: {
    shopSettings: {
      handler(value) {
        this.getCurrentSettings();
      },
      deep: true,
    },
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand"]),
    ...mapGlobalGetters({ units: "productUnit" }),
    firmsByBrand() {
      return this.firms.map((item) => {
        return {
          text: item["name"],
          value: item[".key"],
        };
      });
    },
    productsByFirm() {
      return this.products.filter((p) => p.firm == this.currentSettings.firm);
    },
  },
  methods: {
    restructureProductList(indexMain) {
      this.currentSettings.items.map((item, index) => {
        if (indexMain ? index == indexMain : true) {
          let prod = this.products.filter(
            (item1) => item1["name"] == item["productName"]
          )[0];
          this.currentSettings.items[index]["productName"] = prod.name;
          this.currentSettings.items[index]["productId"] = prod[".key"];
          this.currentSettings.items[index]["unit"] = prod.unit;
          this.currentSettings.items[index]["rate"] = this.isBuyer
            ? prod["sellingPrice"] || 0
            : prod["purchasingPrice"] || 0;
          this.currentSettings.items[index]['MRPRate'] = prod.MRPRate || 
          this.currentSettings.items[index]["rate"]
        }
      });
      this.currentSettings = Object.assign({}, this.currentSettings);
    },
    getProd(productId){
      return this.productsByFirm.find(item => item['.key'] == productId); 
    },
    addAllProds(){
      this.currentSettings.items = [];
      let products = this.productsByFirm;
      products.map((item)=>{
        let itemToAdd = {
          productId: item['.key'],
          orignal : true,
          image : {
              fileName: null,
              filePath: null,
              uploadDate: null,
              documentName: null,
            }
        };
        this.currentSettings.items.push(itemToAdd);
      })
       this.currentSettings.items = Object.assign(
        [],
        this.currentSettings.items
      );
    },
    addProd() {
      let itemToAdd = {
        productName: null,
        productId: null,
        unit: null,
        rate: 0,
        MRPRate : 0,
        orignal : false,
         image : {
              fileName: null,
              filePath: null,
              uploadDate: null,
              documentName: null,
            }
      };
      this.currentSettings.items.push(itemToAdd);
      this.currentSettings.items = Object.assign(
        [],
        this.currentSettings.items
      );
    },
    removeProd(index) {
      this.currentSettings.items.splice(index, 1);
      this.currentSettings.items = Object.assign(
        [],
        this.currentSettings.items
      );
    },
    deleteImage(name, filePath) {
      let storagePath = firebase.storage().ref();
      storagePath.child(filePath + `${name}`).delete();
    },
    async uploadAndSave() {
      if (Object.keys(this.productImages).length) {
         let path = productsImagesPath;
          for (const [key, value] of Object.entries(this.productImages)) {
            if (value && this.currentSettings.items[key].image.filePath) {
              this.deleteImage(this.currentSettings.items[key].image.fileName, path);
            }
          }
          for (const [key, value] of Object.entries(this.productImages)) {
            if (value) {
              await this.upload(value, path, key,true).then(() => {
                delete this.productImages[key];
              });
            }
          }
      }
      if (this.brandLogo && this.currentSettings.logo) {
        this.deleteImage(this.currentSettings.logoFileName, logoPath);
      }
      if (this.brandLogo) {
        await this.upload(this.brandLogo, logoPath, [
          "logo",
          "logoFileName",
        ],false).then(() => {
          this.brandLogo = null;
        });
      }
      this.update();
    },
    uploadChangeProduct(event, doc, index) {
        this.productImages[index] = event.target.files[0];
        this.currentSettings.items[index].image.documentName = this.productImages[
          index
        ].name;
        this.currentSettings = Object.assign({},this.currentSettings)
    },

    upload(image, filePath, fields,isProductImage) {
      return new Promise((resolve) => {
        let fileName = new Date().getTime() + "_" + image.name;
        const storageRef = firebase
          .storage()
          .ref(filePath + `${fileName}`)
          .put(image);
        storageRef.on(
          `state_changed`,
          (snapshot) => {
            this.uploadValue =
              (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          },
          (error) => {
            console.log(error.message);
          },
          () => {
            this.uploadValue = 100;
            storageRef.snapshot.ref.getDownloadURL().then((url) => {
              this.uploadValue = 0;
              if(isProductImage) {
                this.currentSettings.items[fields].image.filePath = url;
                this.currentSettings.items[fields].image.fileName = fileName;
                this.currentSettings.items[fields].image.uploadDate = new Date().getTime();
              } else {
                this.currentSettings[fields[0]] = url;
                this.currentSettings[fields[1]] = fileName;
              }

              resolve();
            });
          }
        );
      });
    },
    downloadURI(uri, name) {
      var link = document.createElement("a");
      link.download = name;
      link.href = uri;
      link.target="_blank"
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    uploadChangeLogo(event) {
      this.brandLogo = event.target.files[0];
    },
    update() {
      if (this.currentSettings[".key"]) {
        let key = this.currentSettings[".key"];
        delete this.currentSettings[".key"];
        this.$root.$firebaseRefs.shopSettings
          .child(key)
          .set(this.currentSettings)
          .then(() => {
            this.currentSettings[".key"] = key;
            this.snackbar = true;
          });
      } else {
        this.currentSettings.brand = this.selectedBrand;
        let res = this.$root.$firebaseRefs.shopSettings.push(
          this.currentSettings
        );
        this.currentSettings[".key"] = res["key"];
        this.snackbar = true;
      }
    },
    getCurrentSettings() {
      console.log(this.shopSettings);
      if (this.shopSettings.length) {
        this.currentSettings = this.shopSettings[0];
        if (!this.currentSettings.items || !this.currentSettings.items.length) {
          this.addAllProds();
        } else {
          this.currentSettings.items.map((p,index)=>{
            if(!p.image) {
              this.currentSettings.items[index]['image'] = {
                fileName: null,
                filePath: null,
                uploadDate: null,
                documentName: null,
              }
            }
          })
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Settings/ShopSettings/ShopSettings.vue